import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Input, Tooltip, Icon } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { parseFormControlValue, checkEmptyObject } from "../../../services/utils";
import styles from "./timeInput.scss";

const TimeInput = (props) => {
  const {
    title,
    isRequired,
    placeholder = {},
    fields = {},
    onChange,
    tooltip,
    field,
    isDisabled,
  } = props;

  const getInitialState = (props) => {
    const { value, field } = props;
    if (checkEmptyObject(value) && typeof value[field] === "number") {
      const totalMinutes = value[field];
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      return {
        hours: h.toString(),
        minutes: m.toString(),
      };
    }
    return {
      hours: "",
      minutes: "",
    };
  };

  const [state, setState] = useState(getInitialState(props));
  const prevValue = useRef(props.value);

  useEffect(() => {
    if (prevValue.current !== props.value) {
      setState(getInitialState(props));
      prevValue.current = props.value;
    }
  }, [props]);

  const validateTime = (timeValue, type) => {
    if (timeValue === "") return "";

    const cleanValue = timeValue.replace(/\D/g, "");
    if (cleanValue === "") return "";

    const num = parseInt(cleanValue, 10);
    if (isNaN(num)) return "";

    if (type === "hours") {
      return Math.min(23, Math.max(0, num)).toString();
    } else {
      return Math.min(59, Math.max(0, num)).toString();
    }
  };

  const handleTimeChange = (newHours, newMinutes) => {
    if (newHours !== "" || newMinutes !== "") {
      const h = newHours === "" ? 0 : parseInt(newHours, 10);
      const m = newMinutes === "" ? 0 : parseInt(newMinutes, 10);

      const totalMinutes = h * 60 + m;
      onChange(parseFormControlValue([field], [totalMinutes]));
    }
  };

  const handleHoursChange = (e) => {
    const validatedHours = validateTime(e.target.value, "hours");
    setState({ ...state, hours: validatedHours });
    handleTimeChange(validatedHours, state.minutes);
  };

  const handleMinutesChange = (e) => {
    const validatedMinutes = validateTime(e.target.value, "minutes");
    setState({ ...state, minutes: validatedMinutes });
    handleTimeChange(state.hours, validatedMinutes);
  };

  return (
      <div className={styles.timeInputContainer}>
        {title && (
            <span className={`control-title ${isRequired ? "required" : ""}`}>
          {title}
              {tooltip && (
                  <Tooltip title={tooltip} placement="top">
                    <Icon
                        className={styles.infoIcon}
                        type="info-circle-o"
                    />
                  </Tooltip>
              )}
        </span>
        )}

        <Row gutter={12} className={styles.timeInputRow}>
          <Col span={12}>
            <Input
                value={state.hours}
                placeholder={
                    placeholder.hours ||
                    (fields.hours && fields.hours.placeholder) ||
                    ""
                }
                onChange={handleHoursChange}
                disabled={isDisabled}
                suffix={(fields.hours && fields.hours.title) || "h"}
                inputMode="numeric"
                maxLength={2}
                className={styles.timeInput}
            />
          </Col>
          <Col span={12}>
            <Input
                value={state.minutes}
                placeholder={
                    placeholder.minutes ||
                    (fields.minutes && fields.minutes.placeholder) ||
                    ""
                }
                onChange={handleMinutesChange}
                disabled={isDisabled}
                suffix={(fields.minutes && fields.minutes.title) || "min"}
                inputMode="numeric"
                maxLength={2}
                className={styles.timeInput}
            />
          </Col>
        </Row>
      </div>
  );
};

TimeInput.defaultProps = {
  title: "",
  isRequired: false,
  placeholder: {},
  fields: {},
  onChange: () => null,
  isDisabled: false,
};

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components/FormControls/TimeInput/TimeInput.tsx